<template>
    <a-spin :spinning="formOption.busy">
        <a-form :form="form"
                :label-col="{ span: 12 }"
                :wrapper-col="{ span: 12 }"
        >
            <a-row :gutter="24">
                <a-col>
                    <a-form-item label="选择部门"
                                 :label-col="{ span: 2 }"
                                 :wrapper-col="{ span: 8 }">
                        <a-tree-select
                                v-decorator="['deptId',rules.deptId]"
                                allow-clear
                                :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
                                :treeData="treeData"
                                :replaceFields="{children:'children', title:'deptName', key:'deptId', value: 'deptId' }"
                                :disabled="isDisabled()"
                        >
                        </a-tree-select>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="24">
                <a-col>
                    <a-form-item label="计划拜访年月"
                                 :label-col="{ span: 2 }"
                                 :wrapper-col="{ span: 8 }">
                        <!--                        <a-date-picker-->
                        <!--                                valueFormat="YYYY-MM"-->
                        <!--                                v-decorator="['visitingTime', rules.visitingTime]"-->
                        <!--                                picker="month"-->
                        <!--                                placeholder="选择计划拜访年月"-->
                        <!--                        />-->
                        <a-date-picker
                                picker="month"
                                v-decorator="['visitingTime', rules.visitingTime]"
                                format="YYYY-MM"
                                value-format="YYYY-MM"
                                placeholder="选择计划拜访年月"
                                :disabled="isDisabled()"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="第1周拜访数量">
                        <a-input-number :min="0" v-decorator="['firstWeek', rules.firstWeek]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="第2周拜访数量">
                        <a-input-number :min="0" v-decorator="['twoWeek', rules.twoWeek]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="第3周拜访数量">
                        <a-input-number :min="0" v-decorator="['threeWeek', rules.threeWeek]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="第4周拜访数量">
                        <a-input-number :min="0" v-decorator="['fourthWeek', rules.fourthWeek]"/>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>

        <a-space class="a-form-btn-box">
            <a-button @click="close()">取消</a-button>
            <a-button type="primary" @click="submit">下一步</a-button>
        </a-space>
    </a-spin>
</template>

<script>
    import {formMixin, fmt} from '@/utils/common/FormBase'
    import {dataApi} from '@/services/visit/plan';
    import XEUtils from "xe-utils";

    /**
     * 加载规则 必填控制我
     */
    function getRulesTemplate() {
        return {
            deptId: {
                rules: [{required: true, message: "请选择部门"}]
            },
            visitingTime: {
                rules: [{required: true, message: "计划拜访年月"}]
            },
            firstWeek: {
                rules: [{required: true, message: "请输入第1周拜访数量"}]
            },
            twoWeek: {
                rules: [{required: true, message: "请输入第2周拜访数量"}]
            },
            threeWeek: {
                rules: [{required: true, message: "请输入第3周拜访数量"}]
            },
            fourthWeek: {
                rules: [{required: true, message: "请输入第4周拜访数量"}]
            }
        };
    }


    /**
     * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
     * 一般是用来写表单默认值 或者写不在表单中需要保存的值
     * @returns {Object}
     */
    function newEntity() {
        return {
            notify: true
        };
    }


    /**
     * 加载数据
     * @param rowId 主键值
     * @returns {Promise}
     */
    async function loadEntity(rowId) {
        console.log(rowId);
        let entity = await dataApi.getFormDetail(rowId);
        // entity.data.visitingTime = [entity.data.startTime, entity.data.endTime];
        console.log(entity);

        this.id = entity.data.id;
        this.deptId = entity.data.deptId;
        this.visitingTime = entity.data.visitingTime;
        this.firstWeek = entity.data.firstWeek;
        this.twoWeek = entity.data.twoWeek;
        this.threeWeek = entity.data.threeWeek;
        this.fourthWeek = entity.data.fourthWeek;
        return fmt.formatFormLoad(entity);
    }


    /**
     * 加载数据之后执行的函数(新建表单也会执行)
     */
    function afterLoad(entity) {
        console.log(entity)
    }


    /**
     * 提交数据
     * @param entities
     * @param vm
     * @returns {Promise}
     */
    async function submit() {
        let entities = null;
        const vm = this
        this.form.validateFieldsAndScroll((err, values) => {
            if (!err) {//无任何错误 向下执行
                entities = values;
            }
        });
        entities.id = vm.rowId;
        console.log(entities);
        await dataApi.saveFormDetail(entities).then(res => {
            if (res.code === 200) {
                this.$emit('saved')
            } else {
                this.$message.error(res.msg)
            }
        })
    }

    /**
     * 加载基础数据
     */
    async function loadBaseData() {
        // let region = {
        //     isRegion: 1,
        //     isDealer: 0
        // }
        // this.regionOptions = await dataApi.selection(region);//经理部
        // this.treeData = XEUtils.toArrayTree(this.regionOptions.data, {
        //     key: 'deptId',
        //     parentKey: 'parentId',
        //     children: 'children'
        // });
        // dataApi.popSelectVisit().then(res => {
        //     this.treeData = XEUtils.toArrayTree(res.data, {
        //         parentKey: 'parentId',
        //         key: 'deptId',
        //         children: 'children'
        //     });
        // })
        dataApi.popSelect().then(res => {
            this.treeData = XEUtils.toArrayTree(res.data, {
                parentKey: 'parentId',
                key: 'deptId',
                children: 'children'
            })
        })
    }


    /**
     * 表单组件
     */
    export default {
        mixins: [formMixin],
        components: {
            // userPickerWithNoParents
        },
        data() {
            return {
                visitingTime: null,
                treeData: [],
                id: null
            }
        },
        mounted() {

        },
        methods: {
            loadEntity,
            newEntity,
            submit,
            getRulesTemplate,
            afterLoad,
            loadBaseData,
            insert(text, index) {
                const vm = this
                this.$nextTick(() => {
                    if (index === 2) {
                        console.log(text)
                        vm.$refs.chatInput1.insertHtmlAtCaret(text)
                    } else {
                        console.log(text)
                        vm.$refs.chatInput.insertHtmlAtCaret(text)
                    }
                })
            },
            cancel() {
                this.$emit('cancel')
            },
            isDisabled() {
                // console.log("🚀 ~ isDisabled ~ this.formType:", this.formType)
                return this.id !== null && this.id !== 0;
            }
        }
    };
</script>
